import { Component } from '@angular/core';
import { BarChartComponent } from '../../../charts/bar-chart.component'; 

@Component({
  selector: 'app-oral-test-graph',
  standalone: true,
  imports: [BarChartComponent],
  template: `
    <div class="flex items-center gap-3">
      <div class="w-[15rem] flex flex-col items-center justify-center overflow-hidden">
        <h2 class="text-7xl font-bold mt-3 ">95</h2>
        <h2 class="text-sm font-bold text-zinc-500 capitalize">oral test</h2>
      </div>
      <div class="w-full "><app-bar-chart [height]="200"  [yAxisLabel]="false"></app-bar-chart>
      </div>
    </div>
  `,
  styles: ``
})
export class OralTestGraphComponent {

}
